// extracted by mini-css-extract-plugin
export default {"grid":"gallery_grid__V-x0X","gridImage":"gallery_gridImage__6CKSL","lightbox":"gallery_lightbox__XhRHh","closeButton":"gallery_closeButton__lQ6So"};